import { IconProps } from "../types/icon";

export const BreadIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M9.732 1.076A3.62 3.62 0 0 0 8.71 3.221c.903.499 1.6 1.3 1.969 2.263A5.2 5.2 0 0 0 8.733 4.4a3.67 3.67 0 0 0-3.328 1 3.62 3.62 0 0 0-1.022 2.15 4.37 4.37 0 0 1 1.969 2.261 5.14 5.14 0 0 0-1.946-1.08 3.672 3.672 0 1 0 1.864 6.191l8.655-8.654a3.672 3.672 0 1 0-5.193-5.192"
      />
    </svg>
  );
};
